// import React, { useState, useEffect } from 'react';
// import { FaUser, FaTimes, FaSave } from 'react-icons/fa';
// import { Link, useNavigate } from 'react-router-dom';
// import { db } from '../../firebaseConfig';
// import { ref, get, update } from 'firebase/database';
// import { getAuth, signOut, onAuthStateChanged } from 'firebase/auth';
// import logo from '../../assets/logo.jpg'; // Adjust the path as necessary
// const Navbar1 = () => {
//   const [showSettings, setShowSettings] = useState(false);
//   const [showBookings, setShowBookings] = useState(false);
//   const [showSettingsForm, setShowSettingsForm] = useState(false);
//   const [userData, setUserData] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [formData, setFormData] = useState({
//     firstName: '',
//     lastName: '',
//     companyName: '',
//     mobile: '',
//     email: '',
//     address: '',
//   });
//   const navigate = useNavigate();
//   const auth = getAuth();

//   const handleLogout = async () => {
//     try {
//       await signOut(auth);
//       localStorage.removeItem("agent");
//       navigate("/agent-connect");
//     } catch (error) {
//       console.error("Logout error:", error);
//       setError("Failed to logout. Please try again.");
//     }
//   };

//   useEffect(() => {
//     const unsubscribe = onAuthStateChanged(auth, async (user) => {
//       if (!user) {
//         navigate("/agent-connect");
//         return;
//       }

//       try {
//         setLoading(true);
//         const emailKey = user.email.replace(/\./g, '_');
//         const userRef = ref(db, `Agent/${emailKey}`);
//         const snapshot = await get(userRef);
        
//         if (snapshot.exists()) {
//           const data = snapshot.val();
//           setUserData(data);
//           setFormData({
//             firstName: data.firstName || '',
//             lastName: data.lastName || '',
//             companyName: data.companyName || '',
//             mobile: data.mobile || '',
//             email: data.email || '',
//             address: data.address || '',
//           });
//         } else {
//           const cachedData = localStorage.getItem("agent");
//           if (cachedData) {
//             const data = JSON.parse(cachedData);
//             setUserData(data);
//             setFormData({
//               firstName: data.firstName || '',
//               lastName: data.lastName || '',
//               companyName: data.companyName || '',
//               mobile: data.mobile || '',
//               email: data.email || '',
//               address: data.address || '',
//             });
//           } else {
//             throw new Error('No user data available');
//           }
//         }
//       } catch (err) {
//         console.error("Error fetching user data:", err);
//         setError(err.message);
//       } finally {
//         setLoading(false);
//       }
//     });

//     return () => unsubscribe();
//   }, [auth, navigate]);

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setFormData(prev => ({ ...prev, [name]: value }));
//   };

//   const handleSettingsSubmit = async (e) => {
//     e.preventDefault();
//     setLoading(true);
//     try {
//       const emailKey = userData.email.replace(/\./g, '_');
//       const userRef = ref(db, `Agent/${emailKey}`);
//       await update(userRef, formData);
      
//       // Update local data
//       const updatedData = { ...userData, ...formData };
//       setUserData(updatedData);
//       localStorage.setItem("agent", JSON.stringify(updatedData));
      
//       setShowSettingsForm(false);
//     } catch (err) {
//       console.error("Error updating settings:", err);
//       setError("Failed to update settings. Please try again.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const styles = {
//     container: {
//       fontFamily: 'Arial, sans-serif',
//       fontSize: '14px',
//       position: 'relative',
//     },
//     top: {
//       display: 'flex',
//       justifyContent: 'flex-end',
//       gap: '20px',
//       padding: '8px 20px',
//       color: '#999',
//       borderBottom: '1px solid #ddd',
//       backgroundColor: '#f8f8f8',
//     },
//     main: {
//       display: 'flex',
//       alignItems: 'center',
//       justifyContent: 'space-between',
//       padding: '15px 20px',
//       backgroundColor: '#fff',
//       boxShadow: '0 2px 5px rgba(0, 0, 0, 0.05)',
//     },
//     logo: {
//       display: 'flex',
//       alignItems: 'center',
//     },
//     logoCircle: {
//       width: '60px',
//       height: '60px',
//       backgroundColor: '#c1212a',
//       borderRadius: '50%',
//       color: 'white',
//       textAlign: 'center',
//       fontWeight: 'bold',
//       lineHeight: '1.2',
//       paddingTop: '10px',
//       fontSize: '12px',
//       display: 'flex',
//       flexDirection: 'column',
//       justifyContent: 'center',
//     },
//     logoSmall: {
//       fontSize: '10px',
//       display: 'block',
//       marginTop: '3px',
//     },
//     navLinks: {
//       listStyle: 'none',
//       display: 'flex',
//       gap: '25px',
//       margin: 0,
//       padding: 0,
//     },
//     navItem: {
//       fontWeight: 'bold',
//       cursor: 'pointer',
//       position: 'relative',
//       color: '#333',
//       transition: 'color 0.2s',
//       '&:hover': {
//         color: '#c1212a',
//       },
//     },
//     userIcon: {
//       marginRight: '5px',
//       verticalAlign: 'middle',
//     },
//     logoutButton: {
//       background: 'none',
//       border: 'none',
//       color: '#666',
//       cursor: 'pointer',
//       fontWeight: 'bold',
//       padding: '0',
//       '&:hover': {
//         color: '#c1212a',
//       },
//     },
//     dropdown: {
//       position: 'absolute',
//       top: '100%',
//       left: '50%',
//       transform: 'translateX(-50%)',
//       minWidth: '180px',
//       zIndex: 1000,
//       marginTop: '5px',
//     },
//     arrow: {
//       width: 0,
//       height: 0,
//       borderLeft: '10px solid transparent',
//       borderRight: '10px solid transparent',
//       borderBottom: '10px solid #c1212a',
//       position: 'absolute',
//       top: '-10px',
//       left: '50%',
//       transform: 'translateX(-50%)',
//     },
//     dropdownMenu: {
//       border: '1px solid #ddd',
//       borderRadius: '4px',
//       boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
//       overflow: 'hidden',
//     },
//     redItem: {
//       backgroundColor: '#c1212a',
//       color: 'white',
//       padding: '10px 20px',
//       cursor: 'pointer',
//       transition: 'background-color 0.2s',
//       '&:hover': {
//         backgroundColor: '#a51b23',
//       },
//     },
//     whiteItem: {
//       backgroundColor: 'white',
//       color: '#333',
//       padding: '10px 20px',
//       cursor: 'pointer',
//       transition: 'background-color 0.2s',
//       '&:hover': {
//         backgroundColor: '#f5f5f5',
//       },
//     },
//     link: {
//       textDecoration: 'none',
//       display: 'block',
//     },
//     loadingText: {
//       color: '#666',
//       fontStyle: 'italic',
//     },
//     errorText: {
//       color: '#d32f2f',
//     },
//     modalOverlay: {
//       position: 'fixed',
//       top: 0,
//       left: 0,
//       right: 0,
//       bottom: 0,
//       backgroundColor: 'rgba(0, 0, 0, 0.5)',
//       display: 'flex',
//       justifyContent: 'center',
//       alignItems: 'center',
//       zIndex: 2000,
//     },
//     modalContent: {
//       backgroundColor: '#fff',
//       padding: '20px',
//       borderRadius: '8px',
//       width: '500px',
//       maxWidth: '90%',
//       boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
//     },
//     modalHeader: {
//       display: 'flex',
//       justifyContent: 'space-between',
//       alignItems: 'center',
//       marginBottom: '20px',
//       borderBottom: '1px solid #eee',
//       paddingBottom: '10px',
//     },
//     modalTitle: {
//       fontSize: '18px',
//       fontWeight: 'bold',
//       color: '#c1212a',
//     },
//     closeButton: {
//       background: 'none',
//       border: 'none',
//       cursor: 'pointer',
//       fontSize: '18px',
//       color: '#666',
//     },
//     formGroup: {
//       marginBottom: '15px',
//     },
//     formLabel: {
//       display: 'block',
//       marginBottom: '5px',
//       fontWeight: 'bold',
//       fontSize: '14px',
//     },
//     formInput: {
//       width: '100%',
//       padding: '8px 12px',
//       border: '1px solid #ddd',
//       borderRadius: '4px',
//       fontSize: '14px',
//     },
//     formActions: {
//       display: 'flex',
//       justifyContent: 'flex-end',
//       gap: '10px',
//       marginTop: '20px',
//     },
//     saveButton: {
//       backgroundColor: '#c1212a',
//       color: 'white',
//       border: 'none',
//       padding: '8px 16px',
//       borderRadius: '4px',
//       cursor: 'pointer',
//       display: 'flex',
//       alignItems: 'center',
//       gap: '5px',
//     },
//     cancelButton: {
//       backgroundColor: '#f0f0f0',
//       color: '#333',
//       border: 'none',
//       padding: '8px 16px',
//       borderRadius: '4px',
//       cursor: 'pointer',
//     },
//   };

//   if (loading) {
//     return (
//       <div style={styles.container}>
//         <div style={styles.top}>
//           <span style={styles.loadingText}>Loading user data...</span>
//         </div>
//       </div>
//     );
//   }

//   if (error) {
//     return (
//       <div style={styles.container}>
//         <div style={styles.top}>
//           <span style={styles.errorText}>Error: {error}</span>
//           <button onClick={handleLogout} style={styles.logoutButton}>
//             Logout
//           </button>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div style={styles.container}>
//       {/* Top Bar */}
//       <div style={styles.top}>
//        <span style={styles.navItem}>
//             <FaUser style={styles.userIcon}/> 
//             {userData?.firstName?.toUpperCase() || 'USER'} {userData?.lastName?.toUpperCase() || ''} 
//           </span>


//         <span style={styles.navItem}>{userData?.companyName || 'My Company'}</span>
      
//         <button onClick={handleLogout} style={styles.logoutButton}>
//           Logout
//         </button>
//       </div>

//       {/* Main Navbar */}
//       <div style={styles.main}>
//         <div style={styles.logo}>
          
//            <img src={logo} style={{
//             width: '80px',
//             height: '80px',
//             borderRadius: '50%',
//             objectFit: 'cover',
//            }}></img>
          
//         </div>

//         <ul style={styles.navLinks}>
//           <Link to="/departure" style={styles.navItem}>
//             Departure
//           </Link>
//           <Link to="/agent-international-tours" style={styles.navItem}>International</Link>
//           <Link to= "/agent-domestic-tours" style={styles.navItem}>Domestic</Link>


//           <Link to="/agent-packages" style={styles.navItem}>Our Packages</Link>

          


//           <li
//   style={styles.navItem}
//   onMouseEnter={() => setShowSettings(true)}
//   onMouseLeave={() => setShowSettings(false)}
// >
//   Settings ▾
//   {showSettings && (
//     <div style={styles.dropdown}>
//       <div style={styles.arrow}></div>
//       <div style={styles.dropdownMenu}>
//         <div 
//           style={styles.redItem} 
//           onClick={() => {
//             setShowSettings(false);
//             navigate('/Settings');
//             setShowSettingsForm(true); // Opens settings form modal
//           }}
//         >
//           setting
//         </div>
//         <div 
//           style={styles.whiteItem} 
//           onClick={() => {
//             setShowSettings(false);
//             navigate('/hotelmarkup'); // Navigates to hotel markup page
//           }}
//         >
//           Hotel Markup
//         </div>
//       </div>
//     </div>
//   )}
// </li>

         
//         </ul>
//       </div>
//     </div>
//   );
// };

// export default Navbar1;








// import React, { useState, useEffect } from 'react';
// import { 
//   FaUser, 
//   FaTimes, 
//   FaSave, 
//   FaBars, 
//   FaChevronDown, 
//   FaChevronUp, 
//   FaSignOutAlt,
//   FaCog,
//   FaHotel,
//   FaGlobeAmericas,
//   FaHome,
//   FaPlaneDeparture,
//   FaBoxOpen
// } from 'react-icons/fa';
// import { Link, useNavigate, useLocation } from 'react-router-dom';
// import { db } from '../../firebaseConfig';
// import { ref, get, update } from 'firebase/database';
// import { getAuth, signOut, onAuthStateChanged } from 'firebase/auth';
// import logo from '../../assets/logo.jpg';
// import styled, { keyframes, css } from 'styled-components';

// // Animation keyframes
// const fadeIn = keyframes`
//   from { opacity: 0; transform: translateY(-10px); }
//   to { opacity: 1; transform: translateY(0); }
// `;

// const slideIn = keyframes`
//   from { transform: translateX(100%); }
//   to { transform: translateX(0); }
// `;

// const pulse = keyframes`
//   0% { box-shadow: 0 0 0 0 rgba(193, 33, 42, 0.4); }
//   70% { box-shadow: 0 0 0 10px rgba(193, 33, 42, 0); }
//   100% { box-shadow: 0 0 0 0 rgba(193, 33, 42, 0); }
// `;

// const AnimatedDropdown = styled.div`
//   animation: ${fadeIn} 0.3s ease-out forwards;
// `;

// const MobileMenu = styled.div`
//   animation: ${slideIn} 0.3s ease-out forwards;
// `;

// const PulseAnimation = styled.div`
//   ${({ isPulsing }) => isPulsing && css`
//     animation: ${pulse} 1.5s infinite;
//   `}
// `;

// const NavbarContainer = styled.div`
//   font-family: 'Poppins', sans-serif;
//   position: sticky;
//   top: 0;
//   left: 0;
//   right: 0;
//   z-index: 1000;
//   transition: all 0.4s ease;
//   background: ${props => props.isScrolled ? 'rgba(255,255,255,0.98)' : 'white'};
//   box-shadow: ${props => props.isScrolled ? '0 4px 20px rgba(0,0,0,0.08)' : 'none'};
//   backdrop-filter: ${props => props.isScrolled ? 'blur(8px)' : 'none'};
// `;

// const ModalOverlay = styled.div`
//   position: fixed;
//   top: 0;
//   left: 0;
//   right: 0;
//   bottom: 0;
//   background-color: rgba(0, 0, 0, 0.5);
//   display: flex;
//   justify-content: center;
//   align-items: flex-start;
//   padding-top: 100px;
//   z-index: 2000;
//   overflow-y: auto;
// `;

// const ModalContent = styled.div`
//   background-color: #fff;
//   padding: 30px;
//   border-radius: 16px;
//   width: 90%;
//   max-width: 500px;
//   box-shadow: 0 15px 40px rgba(0, 0, 0, 0.2);
//   box-sizing: border-box;
//   margin-bottom: 50px;
//   margin-top: 50px;
// `;

// const Navbar1 = () => {
//   const [showSettings, setShowSettings] = useState(false);
//   const [showSettingsForm, setShowSettingsForm] = useState(false);
//   const [userData, setUserData] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
//   const [windowWidth, setWindowWidth] = useState(window.innerWidth);
//   const [formData, setFormData] = useState({
//     firstName: '',
//     lastName: '',
//     companyName: '',
//     mobile: '',
//     email: '',
//     address: '',
//   });
//   const [isScrolled, setIsScrolled] = useState(false);
//   const [isLogoPulsing, setIsLogoPulsing] = useState(false);

//   const navigate = useNavigate();
//   const location = useLocation();
//   const auth = getAuth();

//   // Check window width on resize
//   useEffect(() => {
//     const handleResize = () => {
//       setWindowWidth(window.innerWidth);
//       // Close mobile menu if window is resized to desktop width
//       if (window.innerWidth > 768) {
//         setIsMobileMenuOpen(false);
//         setShowSettings(false);
//       }
//     };

//     window.addEventListener('resize', handleResize);
//     return () => window.removeEventListener('resize', handleResize);
//   }, []);

//   // Check scroll position
//   useEffect(() => {
//     const handleScroll = () => {
//       setIsScrolled(window.scrollY > 10);
//     };
//     window.addEventListener('scroll', handleScroll);
//     return () => window.removeEventListener('scroll', handleScroll);
//   }, []);

//   // Handle logout
//   const handleLogout = async () => {
//     try {
//       await signOut(auth);
//       localStorage.removeItem("agent");
//       navigate("/agent-connect");
//     } catch (error) {
//       console.error("Logout error:", error);
//       setError("Failed to logout. Please try again.");
//     }
//   };

//   // Fetch user data
//   useEffect(() => {
//     const unsubscribe = onAuthStateChanged(auth, async (user) => {
//       if (!user) {
//         navigate("/agent-connect");
//         return;
//       }

//       try {
//         setLoading(true);
//         const emailKey = user.email.replace(/\./g, '_');
//         const userRef = ref(db, `Agent/${emailKey}`);
//         const snapshot = await get(userRef);
        
//         if (snapshot.exists()) {
//           const data = snapshot.val();
//           setUserData(data);
//           setFormData({
//             firstName: data.firstName || '',
//             lastName: data.lastName || '',
//             companyName: data.companyName || '',
//             mobile: data.mobile || '',
//             email: data.email || '',
//             address: data.address || '',
//           });
//         } else {
//           const cachedData = localStorage.getItem("agent");
//           if (cachedData) {
//             const data = JSON.parse(cachedData);
//             setUserData(data);
//             setFormData({
//               firstName: data.firstName || '',
//               lastName: data.lastName || '',
//               companyName: data.companyName || '',
//               mobile: data.mobile || '',
//               email: data.email || '',
//               address: data.address || '',
//             });
//           } else {
//             throw new Error('No user data available');
//           }
//         }
//       } catch (err) {
//         console.error("Error fetching user data:", err);
//         setError(err.message);
//       } finally {
//         setLoading(false);
//       }
//     });

//     return () => unsubscribe();
//   }, [auth, navigate]);

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setFormData(prev => ({ ...prev, [name]: value }));
//   };

//   const handleSettingsSubmit = async (e) => {
//     e.preventDefault();
//     setLoading(true);
//     try {
//       const emailKey = userData.email.replace(/\./g, '_');
//       const userRef = ref(db, `Agent/${emailKey}`);
//       await update(userRef, formData);
      
//       const updatedData = { ...userData, ...formData };
//       setUserData(updatedData);
//       localStorage.setItem("agent", JSON.stringify(updatedData));
      
//       setShowSettingsForm(false);
//     } catch (err) {
//       console.error("Error updating settings:", err);
//       setError("Failed to update settings. Please try again.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const toggleMobileMenu = () => {
//     setIsMobileMenuOpen(!isMobileMenuOpen);
//     if (!isMobileMenuOpen) {
//       setShowSettings(false);
//     }
//   };

//   // Styles object
//   const styles = {
//     top: {
//       display: 'flex',
//       justifyContent: 'flex-end',
//       gap: '20px',
//       padding: '10px 30px',
//       color: '#666',
//       borderBottom: '1px solid rgba(238,238,238,0.5)',
//       backgroundColor: isScrolled ? 'transparent' : '#f8f8f8',
//       transition: 'all 0.4s ease',
//     },
//     topMobile: {
//       justifyContent: 'space-between',
//       alignItems: 'center',
//       padding: '10px 20px',
//     },
//     main: {
//       display: 'flex',
//       alignItems: 'center',
//       justifyContent: 'space-between',
//       padding: isScrolled ? '10px 30px' : '15px 30px',
//       backgroundColor: 'transparent',
//       position: 'relative',
//       transition: 'all 0.4s ease',
//     },
//     mainMobile: {
//       padding: '12px 20px',
//       justifyContent: 'space-between',
//     },
//     logo: {
//       display: 'flex',
//       alignItems: 'center',
//       zIndex: 1001,
//       transition: 'transform 0.3s ease',
//       ':hover': {
//         transform: 'scale(1.05)',
//       },
//     },
//     logoImg: {
//       width: isScrolled ? '70px' : '80px',
//       height: isScrolled ? '70px' : '80px',
//       borderRadius: '50%',
//       objectFit: 'cover',
//       border: '3px solid #c1212a',
//       boxShadow: '0 3px 15px rgba(0,0,0,0.1)',
//       transition: 'all 0.4s ease',
//       cursor: 'pointer',
//       ':hover': {
//         boxShadow: '0 5px 20px rgba(0,0,0,0.15)',
//       },
//     },
//     logoImgMobile: {
//       width: '60px',
//       height: '60px',
//     },
//     navLinks: {
//       listStyle: 'none',
//       display: 'flex',
//       gap: '30px',
//       margin: 0,
//       padding: 0,
//     },
//     mobileNavLinks: {
//       listStyle: 'none',
//       margin: 0,
//       padding: '25px 20px',
//       display: isMobileMenuOpen ? 'flex' : 'none',
//       flexDirection: 'column',
//       gap: '18px',
//       backgroundColor: 'rgba(255,255,255,0.98)',
//       position: 'fixed',
//       top: isScrolled ? '110px' : '140px',
//       right: 0,
//       width: '280px',
//       height: 'calc(100vh - 140px)',
//       zIndex: 999,
//       boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
//       backdropFilter: 'blur(8px)',
//       transform: isMobileMenuOpen ? 'translateX(0)' : 'translateX(100%)',
//       transition: 'transform 0.3s cubic-bezier(0.16, 1, 0.3, 1)',
//       overflowY: 'auto',
//     },
//     navItem: {
//       fontWeight: '600',
//       cursor: 'pointer',
//       position: 'relative',
//       color: isScrolled ? '#444' : '#333',
//       transition: 'all 0.3s ease',
//       textDecoration: 'none',
//       fontSize: '15px',
//       padding: '10px 0',
//       display: 'flex',
//       alignItems: 'center',
//       gap: '8px',
//       ':hover': {
//         color: '#c1212a',
//       },
//       '::after': {
//         content: '""',
//         position: 'absolute',
//         bottom: '5px',
//         left: 0,
//         width: '0%',
//         height: '2px',
//         backgroundColor: '#c1212a',
//         transition: 'width 0.3s ease',
//       },
//       ':hover::after': {
//         width: '100%',
//       },
//     },
//     navItemActive: {
//       color: '#c1212a',
//       '::after': {
//         width: '100%',
//       },
//     },
//     navItemMobile: {
//       padding: '15px 0',
//       borderBottom: '1px solid rgba(240,240,240,0.5)',
//     },
//     userIcon: {
//       marginRight: '8px',
//       verticalAlign: 'middle',
//       color: '#c1212a',
//       fontSize: '16px',
//     },
//     logoutButton: {
//       background: 'none',
//       border: '2px solid rgba(193, 33, 42, 0.3)',
//       color: '#666',
//       cursor: 'pointer',
//       fontWeight: '600',
//       padding: '6px 15px',
//       borderRadius: '30px',
//       display: 'flex',
//       alignItems: 'center',
//       gap: '8px',
//       transition: 'all 0.3s ease',
//       ':hover': {
//         color: '#c1212a',
//         backgroundColor: 'rgba(193, 33, 42, 0.1)',
//         borderColor: 'rgba(193, 33, 42, 0.5)',
//         transform: 'translateY(-2px)',
//       },
//     },
//     dropdown: {
//       position: 'absolute',
//       top: 'calc(100% + 8px)',
//       left: '50%',
//       transform: 'translateX(-50%)',
//       minWidth: '220px',
//       zIndex: 1000,
//     },
//     mobileDropdown: {
//       position: 'static',
//       transform: 'none',
//       marginTop: '15px',
//       marginLeft: '20px',
//     },
//     arrow: {
//       width: 0,
//       height: 0,
//       borderLeft: '12px solid transparent',
//       borderRight: '12px solid transparent',
//       borderBottom: '12px solid #c1212a',
//       position: 'absolute',
//       top: '-12px',
//       left: '50%',
//       transform: 'translateX(-50%)',
//       filter: 'drop-shadow(0 -2px 2px rgba(0,0,0,0.05))',
//     },
//     dropdownMenu: {
//       border: '1px solid rgba(238,238,238,0.8)',
//       borderRadius: '12px',
//       boxShadow: '0 8px 25px rgba(0, 0, 0, 0.12)',
//       overflow: 'hidden',
//       background: 'rgba(255,255,255,0.98)',
//       backdropFilter: 'blur(8px)',
//     },
//     redItem: {
//       backgroundColor: '#c1212a',
//       color: 'white',
//       padding: '14px 25px',
//       cursor: 'pointer',
//       transition: 'all 0.3s ease',
//       fontWeight: '500',
//       display: 'flex',
//       alignItems: 'center',
//       gap: '12px',
//       ':hover': {
//         backgroundColor: '#a51b23',
//         paddingLeft: '30px',
//       },
//     },
//     whiteItem: {
//       backgroundColor: 'rgba(255,255,255,0.9)',
//       color: '#333',
//       padding: '14px 25px',
//       cursor: 'pointer',
//       transition: 'all 0.3s ease',
//       fontWeight: '500',
//       display: 'flex',
//       alignItems: 'center',
//       gap: '12px',
//       ':hover': {
//         backgroundColor: 'rgba(245,245,245,0.9)',
//         paddingLeft: '30px',
//       },
//     },
//     link: {
//       textDecoration: 'none',
//       display: 'block',
//       color: 'inherit',
//       width: '100%',
//     },
//     loadingText: {
//       color: '#666',
//       fontStyle: 'italic',
//     },
//     errorText: {
//       color: '#d32f2f',
//       fontWeight: '500',
//     },
//     modalHeader: {
//       display: 'flex',
//       justifyContent: 'space-between',
//       alignItems: 'center',
//       marginBottom: '25px',
//       paddingBottom: '15px',
//       borderBottom: '1px solid #eee',
//     },
//     modalTitle: {
//       fontSize: '22px',
//       fontWeight: '600',
//       color: '#c1212a',
//       display: 'flex',
//       alignItems: 'center',
//       gap: '10px',
//     },
//     closeButton: {
//       background: 'none',
//       border: 'none',
//       cursor: 'pointer',
//       fontSize: '22px',
//       color: '#666',
//       transition: 'all 0.3s ease',
//       ':hover': {
//         color: '#c1212a',
//         transform: 'rotate(90deg)',
//       },
//     },
//     formGroup: {
//       marginBottom: '22px',
//     },
//     formLabel: {
//       display: 'block',
//       marginBottom: '10px',
//       fontWeight: '500',
//       fontSize: '15px',
//       color: '#555',
//       display: 'flex',
//       alignItems: 'center',
//       gap: '8px',
//     },
//     formInput: {
//       width: '100%',
//       padding: '12px 18px',
//       border: '1px solid #ddd',
//       borderRadius: '8px',
//       fontSize: '15px',
//       boxSizing: 'border-box',
//       transition: 'all 0.3s ease',
//       ':focus': {
//         borderColor: '#c1212a',
//         boxShadow: '0 0 0 3px rgba(193, 33, 42, 0.1)',
//         outline: 'none',
//       },
//     },
//     formActions: {
//       display: 'flex',
//       justifyContent: 'flex-end',
//       gap: '15px',
//       marginTop: '30px',
//       paddingTop: '15px',
//       borderTop: '1px solid #eee',
//     },
//     saveButton: {
//       backgroundColor: '#c1212a',
//       color: 'white',
//       border: 'none',
//       padding: '12px 25px',
//       borderRadius: '8px',
//       cursor: 'pointer',
//       display: 'flex',
//       alignItems: 'center',
//       gap: '10px',
//       fontWeight: '500',
//       transition: 'all 0.3s ease',
//       ':hover': {
//         backgroundColor: '#a51b23',
//         transform: 'translateY(-2px)',
//         boxShadow: '0 5px 15px rgba(193, 33, 42, 0.3)',
//       },
//     },
//     cancelButton: {
//       backgroundColor: '#f8f8f8',
//       color: '#333',
//       border: 'none',
//       padding: '12px 25px',
//       borderRadius: '8px',
//       cursor: 'pointer',
//       fontWeight: '500',
//       transition: 'all 0.3s ease',
//       ':hover': {
//         backgroundColor: '#eee',
//       },
//     },
//     mobileMenuButton: {
//       background: 'none',
//       border: 'none',
//       fontSize: '26px',
//       cursor: 'pointer',
//       color: isScrolled ? '#444' : '#333',
//       zIndex: 1002,
//       padding: '8px',
//       borderRadius: '50%',
//       transition: 'all 0.3s ease',
//       display: 'flex',
//       alignItems: 'center',
//       justifyContent: 'center',
//       ':hover': {
//         color: '#c1212a',
//         backgroundColor: 'rgba(193, 33, 42, 0.1)',
//       },
//     },
//     mobileUserInfo: {
//       display: 'flex',
//       alignItems: 'center',
//       gap: '12px',
//       fontWeight: '600',
//       color: isScrolled ? '#444' : '#333',
//       fontSize: '15px',
//     },
//     settingsToggle: {
//       display: 'flex',
//       alignItems: 'center',
//       gap: '10px',
//       transition: 'all 0.3s ease',
//       ':hover': {
//         color: '#c1212a',
//       },
//     },
//     companyName: {
//       fontWeight: '600',
//       color: isScrolled ? '#444' : '#333',
//       transition: 'all 0.3s ease',
//       fontSize: '15px',
//       ':hover': {
//         color: '#c1212a',
//       },
//     },
//     iconWrapper: {
//       display: 'inline-flex',
//       alignItems: 'center',
//       justifyContent: 'center',
//       width: '24px',
//       height: '24px',
//     },
//   };

//   if (loading) {
//     return (
//       <NavbarContainer isScrolled={isScrolled}>
//         <div style={{ ...styles.top, ...(windowWidth <= 768 && styles.topMobile) }}>
//           <span style={styles.loadingText}>Loading user data...</span>
//         </div>
//       </NavbarContainer>
//     );
//   }

//   if (error) {
//     return (
//       <NavbarContainer isScrolled={isScrolled}>
//         <div style={{ ...styles.top, ...(windowWidth <= 768 && styles.topMobile) }}>
//           <span style={styles.errorText}>Error: {error}</span>
//           {windowWidth > 768 && (
//             <button onClick={handleLogout} style={styles.logoutButton}>
//               <FaSignOutAlt /> Logout
//             </button>
//           )}
//         </div>
//       </NavbarContainer>
//     );
//   }

//   const renderDesktopNav = () => (
//     <ul style={styles.navLinks}>
//       <li>
//         <Link 
//           to="/departure" 
//           style={{ 
//             ...styles.link, 
//             ...styles.navItem,
//             ...(location.pathname === '/departure' && styles.navItemActive)
//           }}
//         >
//           <div style={styles.iconWrapper}><FaPlaneDeparture /></div>
//           Departure
//         </Link>
//       </li>
//       <li>
//         <Link 
//           to="/agent-international-tours" 
//           style={{ 
//             ...styles.link, 
//             ...styles.navItem,
//             ...(location.pathname === '/agent-international-tours' && styles.navItemActive)
//           }}
//         >
//           <div style={styles.iconWrapper}><FaGlobeAmericas /></div>
//           International
//         </Link>
//       </li>
//       <li>
//         <Link 
//           to="/agent-domestic-tours" 
//           style={{ 
//             ...styles.link, 
//             ...styles.navItem,
//             ...(location.pathname === '/agent-domestic-tours' && styles.navItemActive)
//           }}
//         >
//           <div style={styles.iconWrapper}><FaHome /></div>
//           Domestic
//         </Link>
//       </li>
//       <li>
//         <Link 
//           to="/agent-packages" 
//           style={{ 
//             ...styles.link, 
//             ...styles.navItem,
//             ...(location.pathname === '/agent-packages' && styles.navItemActive)
//           }}
//         >
//           <div style={styles.iconWrapper}><FaBoxOpen /></div>
//           Our Packages
//         </Link>
//       </li>
//       <li
//         style={{...styles.navItem, position: 'relative'}}
//         onMouseEnter={() => setShowSettings(true)}
//         onMouseLeave={() => setShowSettings(false)}
//       >
//         <div style={styles.settingsToggle}>
//           <div style={styles.iconWrapper}><FaCog /></div>
//           Settings <FaChevronDown size={14} />
//         </div>
//         {showSettings && (
//           <AnimatedDropdown style={styles.dropdown}>
//             <div style={styles.arrow}></div>
//             <div style={styles.dropdownMenu}>
//               <Link 
//                 to="/Settings" 
//                 style={styles.link}
//                 onClick={() => {
//                   setShowSettings(false);
//                   setShowSettingsForm(true);
//                 }}
//               >
//                 <div style={styles.redItem}>
//                   <FaUser /> Profile Settings
//                 </div>
//               </Link>
//               <Link 
//                 to="/hotelmarkup" 
//                 style={styles.link}
//                 onClick={() => setShowSettings(false)}
//               >
//                 <div style={styles.whiteItem}>
//                   <FaHotel /> Hotel Markup
//                 </div>
//               </Link>
//             </div>
//           </AnimatedDropdown>
//         )}
//       </li>
//       <li style={{...styles.navItem, display: 'flex', alignItems: 'center'}}>
//         <FaUser style={styles.userIcon} /> 
//         <span>
//           {userData?.firstName?.toUpperCase() || 'USER'} {userData?.lastName?.toUpperCase() || ''}
//         </span>
//       </li>
//     </ul>
//   );

//   const renderMobileNav = () => (
//     <>
//       <div style={styles.mobileUserInfo}>
//         <FaUser style={styles.userIcon} />
//         <span>{userData?.firstName?.toUpperCase() || 'USER'} {userData?.lastName?.toUpperCase() || ''}</span>
//       </div>
//       <button onClick={toggleMobileMenu} style={styles.mobileMenuButton}>
//         {isMobileMenuOpen ? <FaTimes /> : <FaBars />}
//       </button>
//       <MobileMenu style={styles.mobileNavLinks}>
//         <li>
//           <Link 
//             to="/departure" 
//             style={{ 
//               ...styles.link, 
//               ...styles.navItem, 
//               ...styles.navItemMobile,
//               ...(location.pathname === '/departure' && styles.navItemActive)
//             }} 
//             onClick={toggleMobileMenu}
//           >
//             <FaPlaneDeparture /> Departure
//           </Link>
//         </li>
//         <li>
//           <Link 
//             to="/agent-international-tours" 
//             style={{ 
//               ...styles.link, 
//               ...styles.navItem, 
//               ...styles.navItemMobile,
//               ...(location.pathname === '/agent-international-tours' && styles.navItemActive)
//             }} 
//             onClick={toggleMobileMenu}
//           >
//             <FaGlobeAmericas /> International
//           </Link>
//         </li>
//         <li>
//           <Link 
//             to="/agent-domestic-tours" 
//             style={{ 
//               ...styles.link, 
//               ...styles.navItem, 
//               ...styles.navItemMobile,
//               ...(location.pathname === '/agent-domestic-tours' && styles.navItemActive)
//             }} 
//             onClick={toggleMobileMenu}
//           >
//             <FaHome /> Domestic
//           </Link>
//         </li>
//         <li>
//           <Link 
//             to="/agent-packages" 
//             style={{ 
//               ...styles.link, 
//               ...styles.navItem, 
//               ...styles.navItemMobile,
//               ...(location.pathname === '/agent-packages' && styles.navItemActive)
//             }} 
//             onClick={toggleMobileMenu}
//           >
//             <FaBoxOpen /> Our Packages
//           </Link>
//         </li>
//         <li
//           style={{ ...styles.navItem, ...styles.navItemMobile }}
//           onClick={() => setShowSettings(!showSettings)}
//         >
//           <div style={styles.settingsToggle}>
//             <FaCog /> Settings {showSettings ? <FaChevronUp size={14} /> : <FaChevronDown size={14} />}
//           </div>
//           {showSettings && (
//             <AnimatedDropdown style={styles.mobileDropdown}>
//               <div style={styles.dropdownMenu}>
//                 <Link 
//                   to="/Settings" 
//                   style={styles.link}
//                   onClick={() => {
//                     setShowSettings(false);
//                     setShowSettingsForm(true);
//                     toggleMobileMenu();
//                   }}
//                 >
//                   <div style={styles.redItem}>
//                     <FaUser /> Profile Settings
//                   </div>
//                 </Link>
//                 <Link 
//                   to="/hotelmarkup" 
//                   style={styles.link}
//                   onClick={() => {
//                     setShowSettings(false);
//                     toggleMobileMenu();
//                   }}
//                 >
//                   <div style={styles.whiteItem}>
//                     <FaHotel /> Hotel Markup
//                   </div>
//                 </Link>
//               </div>
//             </AnimatedDropdown>
//           )}
//         </li>
//         <li 
//           style={{ 
//             ...styles.navItem, 
//             ...styles.navItemMobile,
//             display: 'flex',
//             alignItems: 'center',
//             gap: '12px',
//           }} 
//           onClick={() => {
//             handleLogout();
//             toggleMobileMenu();
//           }}
//         >
//           <FaSignOutAlt /> Logout
//         </li>
//       </MobileMenu>
//     </>
//   );

//   return (
//     <>
//       <NavbarContainer isScrolled={isScrolled}>
//         {/* Top Bar */}
//         <div style={{ ...styles.top, ...(windowWidth <= 768 && styles.topMobile) }}>
//           <span style={{...styles.companyName, ...(windowWidth <= 768 && {fontSize: '14px'})}}>
//             {userData?.companyName || 'My Company'}
//           </span>
//           {windowWidth > 768 && (
//             <button onClick={handleLogout} style={styles.logoutButton}>
//               <FaSignOutAlt /> Logout
//             </button>
//           )}
//         </div>

//         {/* Main Navbar */}
//         <div style={{ ...styles.main, ...(windowWidth <= 768 && styles.mainMobile) }}>
//           <div style={styles.logo}>
//             <PulseAnimation isPulsing={isLogoPulsing}>
//               <img 
//                 src={logo} 
//                 style={{ 
//                   ...styles.logoImg, 
//                   ...(windowWidth <= 768 && styles.logoImgMobile),
//                 }} 
//                 alt="Company Logo" 
//                 onClick={() => navigate('/')}
//                 onMouseEnter={() => setIsLogoPulsing(true)}
//                 onMouseLeave={() => setIsLogoPulsing(false)}
//               />
//             </PulseAnimation>
//           </div>

//           {windowWidth > 768 ? renderDesktopNav() : renderMobileNav()}
//         </div>
//       </NavbarContainer>

//       {/* Settings Modal */}
//       {showSettingsForm && (
//         <ModalOverlay>
//           <ModalContent>
//             <div style={styles.modalHeader}>
//               <h3 style={styles.modalTitle}><FaCog /> User Settings</h3>
//               <button 
//                 onClick={() => setShowSettingsForm(false)} 
//                 style={styles.closeButton}
//               >
//                 <FaTimes />
//               </button>
//             </div>
//             <form onSubmit={handleSettingsSubmit}>
//               <div style={styles.formGroup}>
//                 <label style={styles.formLabel}><FaUser /> First Name</label>
//                 <input
//                   type="text"
//                   name="firstName"
//                   value={formData.firstName}
//                   onChange={handleInputChange}
//                   style={styles.formInput}
//                   required
//                 />
//               </div>
//               <div style={styles.formGroup}>
//                 <label style={styles.formLabel}><FaUser /> Last Name</label>
//                 <input
//                   type="text"
//                   name="lastName"
//                   value={formData.lastName}
//                   onChange={handleInputChange}
//                   style={styles.formInput}
//                   required
//                 />
//               </div>
//               <div style={styles.formGroup}>
//                 <label style={styles.formLabel}><FaHotel /> Company Name</label>
//                 <input
//                   type="text"
//                   name="companyName"
//                   value={formData.companyName}
//                   onChange={handleInputChange}
//                   style={styles.formInput}
//                   required
//                 />
//               </div>
//               <div style={styles.formGroup}>
//                 <label style={styles.formLabel}><FaHotel /> Mobile</label>
//                 <input
//                   type="tel"
//                   name="mobile"
//                   value={formData.mobile}
//                   onChange={handleInputChange}
//                   style={styles.formInput}
//                   required
//                 />
//               </div>
//               <div style={styles.formGroup}>
//                 <label style={styles.formLabel}><FaHotel /> Email</label>
//                 <input
//                   type="email"
//                   name="email"
//                   value={formData.email}
//                   onChange={handleInputChange}
//                   style={styles.formInput}
//                   disabled
//                   required
//                 />
//               </div>
//               <div style={styles.formGroup}>
//                 <label style={styles.formLabel}><FaHotel /> Address</label>
//                 <input
//                   type="text"
//                   name="address"
//                   value={formData.address}
//                   onChange={handleInputChange}
//                   style={styles.formInput}
//                 />
//               </div>
//               <div style={styles.formActions}>
//                 <button 
//                   type="button" 
//                   onClick={() => setShowSettingsForm(false)} 
//                   style={styles.cancelButton}
//                 >
//                   Cancel
//                 </button>
//                 <button type="submit" style={styles.saveButton}>
//                   <FaSave /> Save Changes
//                 </button>
//               </div>
//             </form>
//           </ModalContent>
//         </ModalOverlay>
//       )}
//     </>
//   );
// };

// export default Navbar1;












import React, { useState, useEffect } from 'react';
import { 
  FaUser, 
  FaTimes, 
  FaSave, 
  FaBars, 
  FaChevronDown, 
  FaChevronUp, 
  FaSignOutAlt,
  FaCog,
  FaHotel,
  FaGlobeAmericas,
  FaHome,
  FaPlaneDeparture,
  FaBoxOpen
} from 'react-icons/fa';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { db } from '../../firebaseConfig';
import { ref, get, update } from 'firebase/database';
import { getAuth, signOut, onAuthStateChanged } from 'firebase/auth';
import logo from '../../assets/logo.jpg';
import styled, { keyframes, css } from 'styled-components';

// Animation keyframes
const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(-10px); }
  to { opacity: 1; transform: translateY(0); }
`;

const slideIn = keyframes`
  from { transform: translateX(100%); }
  to { transform: translateX(0); }
`;

const pulse = keyframes`
  0% { box-shadow: 0 0 0 0 rgba(193, 33, 42, 0.4); }
  70% { box-shadow: 0 0 0 10px rgba(193, 33, 42, 0); }
  100% { box-shadow: 0 0 0 0 rgba(193, 33, 42, 0); }
`;

const AnimatedDropdown = styled.div`
  animation: ${fadeIn} 0.3s ease-out forwards;
`;

const MobileMenu = styled.div`
  animation: ${slideIn} 0.3s ease-out forwards;
`;

const PulseAnimation = styled.div`
  ${({ isPulsing }) => isPulsing && css`
    animation: ${pulse} 1.5s infinite;
  `}
`;

const NavbarContainer = styled.div`
  font-family: 'Poppins', sans-serif;
  position: sticky;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  transition: all 0.4s ease;
  background: ${props => props.isScrolled ? 'rgba(255,255,255,0.98)' : 'transparent'};
  box-shadow: ${props => props.isScrolled ? '0 4px 20px rgba(0,0,0,0.08)' : 'none'};
  backdrop-filter: ${props => props.isScrolled ? 'blur(8px)' : 'none'};
`;

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding-top: 100px;
  z-index: 2000;
  overflow-y: auto;
`;

const ModalContent = styled.div`
  background-color: #fff;
  padding: 30px;
  border-radius: 16px;
  width: 90%;
  max-width: 500px;
  box-shadow: 0 15px 40px rgba(0, 0, 0, 0.2);
  box-sizing: border-box;
  margin-bottom: 50px;
  margin-top: 50px;
`;

const Navbar1 = () => {
  const [showSettings, setShowSettings] = useState(false);
  const [showSettingsForm, setShowSettingsForm] = useState(false);
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    companyName: '',
    mobile: '',
    email: '',
    address: '',
  });
  const [isScrolled, setIsScrolled] = useState(false);
  const [isLogoPulsing, setIsLogoPulsing] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();
  const auth = getAuth();

  // Check window width on resize
  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
      // Close mobile menu if window is resized to desktop width
      if (window.innerWidth > 768) {
        setIsMobileMenuOpen(false);
        setShowSettings(false);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Check scroll position
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Handle logout
  const handleLogout = async () => {
    try {
      await signOut(auth);
      localStorage.removeItem("agent");
      navigate("/agent-connect");
    } catch (error) {
      console.error("Logout error:", error);
      setError("Failed to logout. Please try again.");
    }
  };

  // Fetch user data
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (!user) {
        navigate("/agent-connect");
        return;
      }

      try {
        setLoading(true);
        const emailKey = user.email.replace(/\./g, '_');
        const userRef = ref(db, `Agent/${emailKey}`);
        const snapshot = await get(userRef);
        
        if (snapshot.exists()) {
          const data = snapshot.val();
          setUserData(data);
          setFormData({
            firstName: data.firstName || '',
            lastName: data.lastName || '',
            companyName: data.companyName || '',
            mobile: data.mobile || '',
            email: data.email || '',
            address: data.address || '',
          });
        } else {
          const cachedData = localStorage.getItem("agent");
          if (cachedData) {
            const data = JSON.parse(cachedData);
            setUserData(data);
            setFormData({
              firstName: data.firstName || '',
              lastName: data.lastName || '',
              companyName: data.companyName || '',
              mobile: data.mobile || '',
              email: data.email || '',
              address: data.address || '',
            });
          } else {
            throw new Error('No user data available');
          }
        }
      } catch (err) {
        console.error("Error fetching user data:", err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    });

    return () => unsubscribe();
  }, [auth, navigate]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSettingsSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const emailKey = userData.email.replace(/\./g, '_');
      const userRef = ref(db, `Agent/${emailKey}`);
      await update(userRef, formData);
      
      const updatedData = { ...userData, ...formData };
      setUserData(updatedData);
      localStorage.setItem("agent", JSON.stringify(updatedData));
      
      setShowSettingsForm(false);
    } catch (err) {
      console.error("Error updating settings:", err);
      setError("Failed to update settings. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
    if (!isMobileMenuOpen) {
      setShowSettings(false);
    }
  };

  // Styles object
  const styles = {
    top: {
      display: 'flex',
      justifyContent: 'flex-end',
      gap: '20px',
      padding: '10px 30px',
      color: '#666',
      borderBottom: '1px solid rgba(238,238,238,0.5)',
      backgroundColor: isScrolled ? 'transparent' : '#f8f8f8',
      transition: 'all 0.4s ease',
    },
    topMobile: {
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: '10px 20px',
    },
    main: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: isScrolled ? '10px 30px' : '15px 30px',
      backgroundColor: 'transparent',
      position: 'relative',
      transition: 'all 0.4s ease',
    },
    mainMobile: {
      padding: '12px 20px',
      justifyContent: 'space-between',
    },
    logo: {
      display: 'flex',
      alignItems: 'center',
      zIndex: 1001,
      transition: 'transform 0.3s ease',
      ':hover': {
        transform: 'scale(1.05)',
      },
    },
    logoImg: {
      width: isScrolled ? '70px' : '80px',
      height: isScrolled ? '70px' : '80px',
      borderRadius: '50%',
      objectFit: 'cover',
      border: '3px solid #c1212a',
      boxShadow: '0 3px 15px rgba(0,0,0,0.1)',
      transition: 'all 0.4s ease',
      cursor: 'pointer',
      ':hover': {
        boxShadow: '0 5px 20px rgba(0,0,0,0.15)',
      },
    },
    logoImgMobile: {
      width: '60px',
      height: '60px',
    },
    navLinks: {
      listStyle: 'none',
      display: 'flex',
      gap: '30px',
      margin: 0,
      padding: 0,
    },
    mobileNavLinks: {
      listStyle: 'none',
      margin: 0,
      padding: '25px 20px',
      display: isMobileMenuOpen ? 'flex' : 'none',
      flexDirection: 'column',
      gap: '18px',
      backgroundColor: 'rgba(255,255,255,0.98)',
      position: 'fixed',
      top: isScrolled ? '110px' : '140px',
      right: 0,
      width: '280px',
      height: 'calc(100vh - 140px)',
      zIndex: 999,
      boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
      backdropFilter: 'blur(8px)',
      transform: isMobileMenuOpen ? 'translateX(0)' : 'translateX(100%)',
      transition: 'transform 0.3s cubic-bezier(0.16, 1, 0.3, 1)',
      overflowY: 'auto',
    },
    navItem: {
      fontWeight: '600',
      cursor: 'pointer',
      position: 'relative',
      color: isScrolled ? '#444' : '#333',
      transition: 'all 0.3s ease',
      textDecoration: 'none',
      fontSize: '15px',
      padding: '10px 0',
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      ':hover': {
        color: '#c1212a',
      },
      '::after': {
        content: '""',
        position: 'absolute',
        bottom: '5px',
        left: 0,
        width: '0%',
        height: '2px',
        backgroundColor: '#c1212a',
        transition: 'width 0.3s ease',
      },
      ':hover::after': {
        width: '100%',
      },
    },
    navItemActive: {
      color: '#c1212a',
      '::after': {
        width: '100%',
      },
    },
    navItemMobile: {
      padding: '15px 0',
      borderBottom: '1px solid rgba(240,240,240,0.5)',
    },
    userIcon: {
      marginRight: '8px',
      verticalAlign: 'middle',
      color: '#c1212a',
      fontSize: '16px',
    },
    logoutButton: {
      background: 'none',
      border: '2px solid rgba(193, 33, 42, 0.3)',
      color: '#666',
      cursor: 'pointer',
      fontWeight: '600',
      padding: '6px 15px',
      borderRadius: '30px',
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      transition: 'all 0.3s ease',
      ':hover': {
        color: '#c1212a',
        backgroundColor: 'rgba(193, 33, 42, 0.1)',
        borderColor: 'rgba(193, 33, 42, 0.5)',
        transform: 'translateY(-2px)',
      },
    },
    dropdown: {
      position: 'absolute',
      top: 'calc(100% + 8px)',
      left: '50%',
      transform: 'translateX(-50%)',
      minWidth: '220px',
      zIndex: 1000,
    },
    mobileDropdown: {
      position: 'static',
      transform: 'none',
      marginTop: '15px',
      marginLeft: '20px',
    },
    arrow: {
      width: 0,
      height: 0,
      borderLeft: '12px solid transparent',
      borderRight: '12px solid transparent',
      borderBottom: '12px solid #c1212a',
      position: 'absolute',
      top: '-12px',
      left: '50%',
      transform: 'translateX(-50%)',
      filter: 'drop-shadow(0 -2px 2px rgba(0,0,0,0.05))',
    },
    dropdownMenu: {
      border: '1px solid rgba(238,238,238,0.8)',
      borderRadius: '12px',
      boxShadow: '0 8px 25px rgba(0, 0, 0, 0.12)',
      overflow: 'hidden',
      background: 'rgba(255,255,255,0.98)',
      backdropFilter: 'blur(8px)',
    },
    redItem: {
      backgroundColor: '#c1212a',
      color: 'white',
      padding: '14px 25px',
      cursor: 'pointer',
      transition: 'all 0.3s ease',
      fontWeight: '500',
      display: 'flex',
      alignItems: 'center',
      gap: '12px',
      ':hover': {
        backgroundColor: '#a51b23',
        paddingLeft: '30px',
      },
    },
    whiteItem: {
      backgroundColor: 'rgba(255,255,255,0.9)',
      color: '#333',
      padding: '14px 25px',
      cursor: 'pointer',
      transition: 'all 0.3s ease',
      fontWeight: '500',
      display: 'flex',
      alignItems: 'center',
      gap: '12px',
      ':hover': {
        backgroundColor: 'rgba(245,245,245,0.9)',
        paddingLeft: '30px',
      },
    },
    link: {
      textDecoration: 'none',
      display: 'block',
      color: 'inherit',
      width: '100%',
    },
    loadingText: {
      color: '#666',
      fontStyle: 'italic',
    },
    errorText: {
      color: '#d32f2f',
      fontWeight: '500',
    },
    modalHeader: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: '25px',
      paddingBottom: '15px',
      borderBottom: '1px solid #eee',
    },
    modalTitle: {
      fontSize: '22px',
      fontWeight: '600',
      color: '#c1212a',
      display: 'flex',
      alignItems: 'center',
      gap: '10px',
    },
    closeButton: {
      background: 'none',
      border: 'none',
      cursor: 'pointer',
      fontSize: '22px',
      color: '#666',
      transition: 'all 0.3s ease',
      ':hover': {
        color: '#c1212a',
        transform: 'rotate(90deg)',
      },
    },
    formGroup: {
      marginBottom: '22px',
    },
    formLabel: {
      display: 'block',
      marginBottom: '10px',
      fontWeight: '500',
      fontSize: '15px',
      color: '#555',
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
    },
    formInput: {
      width: '100%',
      padding: '12px 18px',
      border: '1px solid #ddd',
      borderRadius: '8px',
      fontSize: '15px',
      boxSizing: 'border-box',
      transition: 'all 0.3s ease',
      ':focus': {
        borderColor: '#c1212a',
        boxShadow: '0 0 0 3px rgba(193, 33, 42, 0.1)',
        outline: 'none',
      },
    },
    formActions: {
      display: 'flex',
      justifyContent: 'flex-end',
      gap: '15px',
      marginTop: '30px',
      paddingTop: '15px',
      borderTop: '1px solid #eee',
    },
    saveButton: {
      backgroundColor: '#c1212a',
      color: 'white',
      border: 'none',
      padding: '12px 25px',
      borderRadius: '8px',
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      gap: '10px',
      fontWeight: '500',
      transition: 'all 0.3s ease',
      ':hover': {
        backgroundColor: '#a51b23',
        transform: 'translateY(-2px)',
        boxShadow: '0 5px 15px rgba(193, 33, 42, 0.3)',
      },
    },
    cancelButton: {
      backgroundColor: '#f8f8f8',
      color: '#333',
      border: 'none',
      padding: '12px 25px',
      borderRadius: '8px',
      cursor: 'pointer',
      fontWeight: '500',
      transition: 'all 0.3s ease',
      ':hover': {
        backgroundColor: '#eee',
      },
    },
    mobileMenuButton: {
      background: 'none',
      border: 'none',
      fontSize: '26px',
      cursor: 'pointer',
      color: isScrolled ? '#444' : '#333',
      zIndex: 1002,
      padding: '8px',
      borderRadius: '50%',
      transition: 'all 0.3s ease',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      ':hover': {
        color: '#c1212a',
        backgroundColor: 'rgba(193, 33, 42, 0.1)',
      },
    },
    mobileUserInfo: {
      display: 'flex',
      alignItems: 'center',
      gap: '12px',
      fontWeight: '600',
      color: isScrolled ? '#444' : '#333',
      fontSize: '15px',
    },
    settingsToggle: {
      display: 'flex',
      alignItems: 'center',
      gap: '10px',
      transition: 'all 0.3s ease',
      ':hover': {
        color: '#c1212a',
      },
    },
    companyName: {
      fontWeight: '600',
      color: isScrolled ? '#444' : '#333',
      transition: 'all 0.3s ease',
      fontSize: '15px',
      ':hover': {
        color: '#c1212a',
      },
    },
    iconWrapper: {
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '24px',
      height: '24px',
    },
  };

  if (loading) {
    return (
      <NavbarContainer isScrolled={isScrolled}>
        <div style={{ ...styles.top, ...(windowWidth <= 768 && styles.topMobile) }}>
          <span style={styles.loadingText}>Loading user data...</span>
        </div>
      </NavbarContainer>
    );
  }

  if (error) {
    return (
      <NavbarContainer isScrolled={isScrolled}>
        <div style={{ ...styles.top, ...(windowWidth <= 768 && styles.topMobile) }}>
          <span style={styles.errorText}>Error: {error}</span>
          {windowWidth > 768 && (
            <button onClick={handleLogout} style={styles.logoutButton}>
              <FaSignOutAlt /> Logout
            </button>
          )}
        </div>
      </NavbarContainer>
    );
  }

  const renderDesktopNav = () => (
    <ul style={styles.navLinks}>
      <li>
        <Link 
          to="/departure" 
          style={{ 
            ...styles.link, 
            ...styles.navItem,
            ...(location.pathname === '/departure' && styles.navItemActive)
          }}
        >
          <div style={styles.iconWrapper}><FaPlaneDeparture /></div>
          Departure
        </Link>
      </li>
      <li>
        <Link 
          to="/agent-international-tours" 
          style={{ 
            ...styles.link, 
            ...styles.navItem,
            ...(location.pathname === '/agent-international-tours' && styles.navItemActive)
          }}
        >
          <div style={styles.iconWrapper}><FaGlobeAmericas /></div>
          International
        </Link>
      </li>
      <li>
        <Link 
          to="/agent-domestic-tours" 
          style={{ 
            ...styles.link, 
            ...styles.navItem,
            ...(location.pathname === '/agent-domestic-tours' && styles.navItemActive)
          }}
        >
          <div style={styles.iconWrapper}><FaHome /></div>
          Domestic
        </Link>
      </li>
      <li>
        <Link 
          to="/agent-packages" 
          style={{ 
            ...styles.link, 
            ...styles.navItem,
            ...(location.pathname === '/agent-packages' && styles.navItemActive)
          }}
        >
          <div style={styles.iconWrapper}><FaBoxOpen /></div>
          Our Packages
        </Link>
      </li>
      <li
        style={{...styles.navItem, position: 'relative'}}
        onMouseEnter={() => setShowSettings(true)}
        onMouseLeave={() => setShowSettings(false)}
      >
        <div style={styles.settingsToggle}>
          <div style={styles.iconWrapper}><FaCog /></div>
          Settings <FaChevronDown size={14} />
        </div>
        {showSettings && (
          <AnimatedDropdown style={styles.dropdown}>
            <div style={styles.arrow}></div>
            <div style={styles.dropdownMenu}>
              <Link 
                to="/Settings" 
                style={styles.link}
                onClick={() => {
                  setShowSettings(false);
                  setShowSettingsForm(true);
                }}
              >
                <div style={styles.redItem}>
                  <FaUser /> Profile Settings
                </div>
              </Link>
              <Link 
                to="/hotelmarkup" 
                style={styles.link}
                onClick={() => setShowSettings(false)}
              >
                <div style={styles.whiteItem}>
                  <FaHotel /> Hotel Markup
                </div>
              </Link>
            </div>
          </AnimatedDropdown>
        )}
      </li>
      <li style={{...styles.navItem, display: 'flex', alignItems: 'center'}}>
        <FaUser style={styles.userIcon} /> 
        <span>
          {userData?.firstName?.toUpperCase() || 'USER'} {userData?.lastName?.toUpperCase() || ''}
        </span>
      </li>
    </ul>
  );

  const renderMobileNav = () => (
    <>
      <div style={styles.mobileUserInfo}>
        <FaUser style={styles.userIcon} />
        <span>{userData?.firstName?.toUpperCase() || 'USER'} {userData?.lastName?.toUpperCase() || ''}</span>
      </div>
      <button onClick={toggleMobileMenu} style={styles.mobileMenuButton}>
        {isMobileMenuOpen ? <FaTimes /> : <FaBars />}
      </button>
      <MobileMenu style={styles.mobileNavLinks}>
        <li>
          <Link 
            to="/departure" 
            style={{ 
              ...styles.link, 
              ...styles.navItem, 
              ...styles.navItemMobile,
              ...(location.pathname === '/departure' && styles.navItemActive)
            }} 
            onClick={toggleMobileMenu}
          >
            <FaPlaneDeparture /> Departure
          </Link>
        </li>
        <li>
          <Link 
            to="/agent-international-tours" 
            style={{ 
              ...styles.link, 
              ...styles.navItem, 
              ...styles.navItemMobile,
              ...(location.pathname === '/agent-international-tours' && styles.navItemActive)
            }} 
            onClick={toggleMobileMenu}
          >
            <FaGlobeAmericas /> International
          </Link>
        </li>
        <li>
          <Link 
            to="/agent-domestic-tours" 
            style={{ 
              ...styles.link, 
              ...styles.navItem, 
              ...styles.navItemMobile,
              ...(location.pathname === '/agent-domestic-tours' && styles.navItemActive)
            }} 
            onClick={toggleMobileMenu}
          >
            <FaHome /> Domestic
          </Link>
        </li>
        <li>
          <Link 
            to="/agent-packages" 
            style={{ 
              ...styles.link, 
              ...styles.navItem, 
              ...styles.navItemMobile,
              ...(location.pathname === '/agent-packages' && styles.navItemActive)
            }} 
            onClick={toggleMobileMenu}
          >
            <FaBoxOpen /> Our Packages
          </Link>
        </li>
        <li
          style={{ ...styles.navItem, ...styles.navItemMobile }}
          onClick={() => setShowSettings(!showSettings)}
        >
          <div style={styles.settingsToggle}>
            <FaCog /> Settings {showSettings ? <FaChevronUp size={14} /> : <FaChevronDown size={14} />}
          </div>
          {showSettings && (
            <AnimatedDropdown style={styles.mobileDropdown}>
              <div style={styles.dropdownMenu}>
                <Link 
                  to="/Settings" 
                  style={styles.link}
                  onClick={() => {
                    setShowSettings(false);
                    setShowSettingsForm(true);
                    toggleMobileMenu();
                  }}
                >
                  <div style={styles.redItem}>
                    <FaUser /> Profile Settings
                  </div>
                </Link>
                <Link 
                  to="/hotelmarkup" 
                  style={styles.link}
                  onClick={() => {
                    setShowSettings(false);
                    toggleMobileMenu();
                  }}
                >
                  <div style={styles.whiteItem}>
                    <FaHotel /> Hotel Markup
                  </div>
                </Link>
              </div>
            </AnimatedDropdown>
          )}
        </li>
        <li 
          style={{ 
            ...styles.navItem, 
            ...styles.navItemMobile,
            display: 'flex',
            alignItems: 'center',
            gap: '12px',
          }} 
          onClick={() => {
            handleLogout();
            toggleMobileMenu();
          }}
        >
          <FaSignOutAlt /> Logout
        </li>
      </MobileMenu>
    </>
  );

  return (
    <>
      <NavbarContainer isScrolled={isScrolled}>
        {/* Top Bar */}
        <div style={{ ...styles.top, ...(windowWidth <= 768 && styles.topMobile) }}>
          <span style={{...styles.companyName, ...(windowWidth <= 768 && {fontSize: '14px'})}}>
            {userData?.companyName || 'My Company'}
          </span>
          {windowWidth > 768 && (
            <button onClick={handleLogout} style={styles.logoutButton}>
              <FaSignOutAlt /> Logout
            </button>
          )}
        </div>

        {/* Main Navbar */}
        <div style={{ ...styles.main, ...(windowWidth <= 768 && styles.mainMobile) }}>
          <div style={styles.logo}>
            <PulseAnimation isPulsing={isLogoPulsing}>
              <img 
                src={logo} 
                style={{ 
                  ...styles.logoImg, 
                  ...(windowWidth <= 768 && styles.logoImgMobile),
                }} 
                alt="Company Logo" 
                onClick={() => navigate('/')}
                onMouseEnter={() => setIsLogoPulsing(true)}
                onMouseLeave={() => setIsLogoPulsing(false)}
              />
            </PulseAnimation>
          </div>

          {windowWidth > 768 ? renderDesktopNav() : renderMobileNav()}
        </div>
      </NavbarContainer>

      {/* Settings Modal */}
      {showSettingsForm && (
        <ModalOverlay>
          <ModalContent>
            <div style={styles.modalHeader}>
              <h3 style={styles.modalTitle}><FaCog /> User Settings</h3>
              <button 
                onClick={() => setShowSettingsForm(false)} 
                style={styles.closeButton}
              >
                <FaTimes />
              </button>
            </div>
            <form onSubmit={handleSettingsSubmit}>
              <div style={styles.formGroup}>
                <label style={styles.formLabel}><FaUser /> First Name</label>
                <input
                  type="text"
                  name="firstName"
                  value={formData.firstName}
                  onChange={handleInputChange}
                  style={styles.formInput}
                  required
                />
              </div>
              <div style={styles.formGroup}>
                <label style={styles.formLabel}><FaUser /> Last Name</label>
                <input
                  type="text"
                  name="lastName"
                  value={formData.lastName}
                  onChange={handleInputChange}
                  style={styles.formInput}
                  required
                />
              </div>
              <div style={styles.formGroup}>
                <label style={styles.formLabel}><FaHotel /> Company Name</label>
                <input
                  type="text"
                  name="companyName"
                  value={formData.companyName}
                  onChange={handleInputChange}
                  style={styles.formInput}
                  required
                />
              </div>
              <div style={styles.formGroup}>
                <label style={styles.formLabel}><FaHotel /> Mobile</label>
                <input
                  type="tel"
                  name="mobile"
                  value={formData.mobile}
                  onChange={handleInputChange}
                  style={styles.formInput}
                  required
                />
              </div>
              <div style={styles.formGroup}>
                <label style={styles.formLabel}><FaHotel /> Email</label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleInputChange}
                  style={styles.formInput}
                  disabled
                  required
                />
              </div>
              <div style={styles.formGroup}>
                <label style={styles.formLabel}><FaHotel /> Address</label>
                <input
                  type="text"
                  name="address"
                  value={formData.address}
                  onChange={handleInputChange}
                  style={styles.formInput}
                />
              </div>
              <div style={styles.formActions}>
                <button 
                  type="button" 
                  onClick={() => setShowSettingsForm(false)} 
                  style={styles.cancelButton}
                >
                  Cancel
                </button>
                <button type="submit" style={styles.saveButton}>
                  <FaSave /> Save Changes
                </button>
              </div>
            </form>
          </ModalContent>
        </ModalOverlay>
      )}
    </>
  );
};

export default Navbar1;